import React, { useEffect, useState } from "react";
import "./Popup.css";
import { useProperty } from "../../../../PropertyContext";
import { ReservationRateCodeList } from "../../../../Services/Service";

const RateCodePopup = ({ show, onClose, onSelect }) => {
  const { selectedProperty } = useProperty();
  const [loading, setLoading] = useState(false);
  const [ratecode, setRatecode] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchRatecode = async () => {
      if (!selectedProperty?.PropertyID) {
        setRatecode([]);
        return;
      }

      setLoading(true);
      try {
        const result = await ReservationRateCodeList(
          selectedProperty?.PropertyID,
        );
        setRatecode(Array.isArray(result) ? result : []);
      } catch (error) {
        console.log("error get rate code", error);
        setRatecode([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, [selectedProperty]);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredRates = ratecode.filter((rate) => {
    const matchesSearch = `${rate.Code ?? ""} ${rate.Name ?? ""} ${
      rate.Description ?? ""
    }`
      .toLowerCase()
      .includes(searchValue);
    return matchesSearch;
  });
  const selectedRate = ratecode.find((rate) => rate.RateCodeID === selectedId);

  return (
    <div
      id="rateCodePopupBackdrop"
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        id="rateCodePopup"
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rateCodePopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="rateCodePopupTitle" className="modal-title">
              Search and Select Rate Code
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close rate code popup"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                id="rateCodeSearchInput"
                type="search"
                className="form-control"
                placeholder="Use (*) for wildcard search"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">
                Search
              </button>
            </div>

            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table bon-rate-table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    filteredRates.map((rate) => (
                      <tr
                        id={`rate-code-row-${rate.RateCodeID}`}
                        key={rate.RateCodeID}
                        className={
                          selectedId === rate.RateCodeID
                            ? "bon-row-selected"
                            : ""
                        }
                        onClick={() => setSelectedId(rate.RateCodeID)}
                        onDoubleClick={() => onSelect(rate)}
                      >
                        <td>{rate.Code}</td>
                        <td title={rate.Description}>
                          {rate.Description || rate.Name}
                        </td>
                      </tr>
                    ))}
                  {loading && (
                    <tr>
                      <td colSpan="2" className="text-center py-4">
                        Loading rate codes...
                      </td>
                    </tr>
                  )}
                  {!loading && !filteredRates.length && (
                    <tr>
                      <td colSpan="2" className="text-center py-4">
                        No matching rate code found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer bon-lookup-footer">
            <button
              type="button"
              className="btn bon-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              id="selectRateCodeButton"
              type="button"
              className="btn bon-select-button"
              disabled={!selectedRate}
              onClick={() => onSelect(selectedRate)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RateCodePopup;
